var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{key:'loading',staticClass:"loading_div"},[_c('i',{staticClass:"fas fa-spinner loading_animation"}),_c('span',{staticClass:"loading_text"},[_vm._v(" 数据加载中，请稍后... ")])]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }